import React from "react";
import moment from "moment";
import {BookingHistoryByIdWithBookingInfoQuery} from "../../generated/graphql";

export const renderUpdateDate = (createDate?: string, addFromNow?: boolean) => {
    if (!createDate) {
        return null;
    }

    return (
        <div>
            {addFromNow ? `${moment(createDate).fromNow()} | ` : ""}
            {moment(createDate).format("DD.MM.YYYY HH:mm")}
        </div>
    );
};

/**
 * Liefert ein formatiertes Datum als reinen String fuer Stellen, an denen
 * String-Concat (z.B. Modal-Titel) genutzt wird. Loest Bug 2 (Komma vor
 * Datum im Modal-Titel): Wenn man `renderUpdateDate(...).props.children`
 * in einen Template-String steckte, wurde das React-Children-Array
 * `["", "28.04.2026 13:16"]` ueber `Array.toString()` mit Komma gejoint.
 *
 * Diese Helfer-Funktion haelt das Datum bewusst frei von Trennzeichen,
 * damit der Aufrufer das Format steuert.
 */
export const formatHistoryDate = (createDate?: string): string => {
    if (!createDate) {
        return "";
    }
    return moment(createDate).format("DD.MM.YYYY HH:mm");
};

type User = BookingHistoryByIdWithBookingInfoQuery["bookingHistoryByIdWithBookingInfo"][number]["user"];

export const renderUser = (user: User) => {
    if (!user) {
        return null;
    }

    if (user.instructorDetails) {
        const fullName = `${user.instructorDetails.firstname} ${user.instructorDetails.lastname}`;

        if (fullName && fullName !== "") {
            return <div>{fullName}</div>;
        }

        return <div>{user.email}</div>;
    }

    return <div>{user.email}</div>;
};
